module.exports = __webpack_public_path__ + "static/img/risk_03a_2025.2c1ff4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/risk/risk_03a_2025.jpg
// module id = 0I+f
// module chunks = 99